import * as React from 'react';

const TitleEditSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="title-edit_svg__eds-icon--title-edit_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="title-edit_svg__eds-icon--title-edit_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 2v3h1V3h5v10H6v1h5v-1H9V3h5v2h1V2H2z"
        />
        <g
            id="title-edit_svg__eds-icon--title-edit_lines"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M15 9h7v1h-7zM15 13h7v1h-7zM6 17h16v1H6zM6 21h16v1H6z" />
        </g>
    </svg>
);

TitleEditSvg.displayName = 'TitleEditSvg';
export default TitleEditSvg;
